module.exports = __webpack_public_path__ + "static/media/IELTS-AcademicReading-ChoiceAccordion.7f34f793.png";